module.exports = require('./lib/noGetters');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-lazy-cache/noGetters.js
 ** module id = 387
 ** module chunks = 0
 **/